import { FC } from 'react'
import Link from 'next/link'
import styles from './index.module.scss'

type Props = {
  label: string
  href: string
  isActive?: boolean
  isNew?: boolean
  isBeta?: boolean
  isExternal?: boolean
}

export const TabNavBarItem: FC<Props> = ({
  label,
  href,
  isActive = false,
  isNew = false,
  isBeta = false,
  isExternal = false,
}) => {
  if (isExternal) {
    return (
      <div className={styles.container}>
        <div className={styles.menuItem}>
          <a className={styles.link} href={href} target='_blank' rel='noreferrer'>
            {label}
            {isNew && <span className={styles.newBadge}>New</span>}
            {isBeta && <span className={styles.betaBadge}>Beta</span>}
            <div className={styles.externalIcon} />
          </a>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <div className={isActive ? styles.activeItem : styles.menuItem}>
        <Link href={href}>
          <a className={styles.link}>
            {label}
            {isNew && <span className={styles.newBadge}>New</span>}
            {isBeta && <span className={styles.betaBadge}>Beta</span>}
          </a>
        </Link>
      </div>
    </div>
  )
}
